import { render, staticRenderFns } from "./CardNotaItem.vue?vue&type=template&id=619f5274&"
import script from "./CardNotaItem.vue?vue&type=script&lang=js&"
export * from "./CardNotaItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./modules/Home/views/src/components/CardNotaItem.vue
// module id = 800
// module chunks = 0